module.exports = __webpack_public_path__ + "567dade44ae5dde242effda3a6f56471.svg";